module.exports = __webpack_public_path__ + "static/media/logo-johe.69c42a55.JPG";